import { useEffect, useState } from 'react';
import { formatResetCountdown, formatUtcDailyLimitWindowLabel, getUtcDailyLimitWindow, } from './utcDailyLimitWindow';
export function useUtcDailyLimitReset() {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = window.setInterval(() => setNow(new Date()), 60000);
        return () => window.clearInterval(id);
    }, []);
    const limitWindow = getUtcDailyLimitWindow(now);
    const msUntilReset = limitWindow.resetsAt.getTime() - now.getTime();
    return {
        windowLabel: formatUtcDailyLimitWindowLabel(limitWindow),
        resetLabel: formatResetCountdown(msUntilReset),
    };
}
